export default __webpack_public_path__ + "static/media/4-Cloudxier-AdventureIndonesia.b687df44.png";